import { ArrowRight } from "lucide-react";

export const StageProgress = ({ stage }) => (
  <div className="intention-progress" aria-label={`${stage} of 7 journey moments complete`} data-testid="intention-progress">
    {Array.from({ length: 7 }, (_, index) => <i key={index} className={index + 1 < stage ? "complete" : index + 1 === stage ? "active" : ""} data-testid={`intention-progress-dot-${index + 1}`} />)}
  </div>
);

export const StageFrame = ({ eyebrow, title, instruction, children, className = "", testId }) => (
  <section className={`intention-stage ${className}`} data-testid={testId}>
    <div className="intention-stage-heading">
      <p>{eyebrow}</p>
      <h1>{title}</h1>
      {instruction && <span>{instruction}</span>}
    </div>
    {children}
  </section>
);

export const ContinueButton = ({ onClick, disabled, label = "Let it move forward", testId }) => (
  <button type="button" className="intention-continue" onClick={onClick} disabled={disabled} data-testid={testId}>
    <span>{label}</span><ArrowRight size={17} />
  </button>
);

export const JourneyParticles = () => (
  <div className="journey-particles" aria-hidden="true">
    {Array.from({ length: 24 }, (_, index) => <i key={index} style={{ "--p": index, "--x": `${(index * 43) % 100}%`, "--y": `${(index * 67) % 100}%`, "--size": `${2 + (index % 3)}px`, "--alpha": .16 + (index % 5) * .06, "--drift": `${(index % 4) * 18}px` }} />)}
  </div>
);